import React, { ReactElement } from 'react';
import {
  useAppUrlParams,
  UrlParamName,
} from 'hooks/navigation/useAppUrlParams';
import { MemoTemplateWizardCommunicator } from './communicator';
import {
  InspectionTemplatesStoreProvider,
  useInspectionTemplateInitializer,
} from 'store/inspection';

function TemplateWizard(): ReactElement {
  const id = useAppUrlParams(UrlParamName.INSPECTION_TEMPLATE_ID);

  useInspectionTemplateInitializer(id);

  // No WithExportToDocumentation: template wizard has no issue context (PT-7064).
  return (
    <InspectionTemplatesStoreProvider>
      <MemoTemplateWizardCommunicator />
    </InspectionTemplatesStoreProvider>
  );
}

export const MemoTemplateWizard = React.memo(TemplateWizard);
